var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-stepper-content',{attrs:{"step":_vm.step}},[_c('add-offer-modal',{attrs:{"quickadd":true,"installation":_vm.installation},on:{"prev-step":function($event){return _vm.$emit('prev-step')},"close-modal":function($event){return _vm.$emit('close-modal')},"complete":function($event){return _vm.$emit('complete')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }